import React from 'react'

import '../../styles/para.scss'

const Paragraph = (props) => {
    return (
        <div className={`info-container ${props.center}`}>
            {props.children}
        </div>
    )
}

export default Paragraph
